export default __webpack_public_path__ + "static/assets/f14367365739d1618a3b33c93e274a8d.png";